import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { flashErrorMessage } from 'redux-flash'
import {
  MembershipPageHeader,
  MembershipNotifications,
} from 'memberships/components'
import { AutoRenewal, BillingAddress, BillingDetails } from '../components'
import * as actions from 'member-actions'
import * as apiActions from 'api-actions'
import { selectors } from 'memberships/reducer'
import { selectors as memberSelectors } from 'member-reducer'
import {
  AccountType,
  MembershipType,
  API_ERROR_MAP,
  StripeSetupIntentType,
} from 'types'
import { withApiAuth } from 'utils'

const propTypes = {
  account: AccountType.isRequired,
  activeStripeSubscription: PropTypes.object,
  cancelStripeSubscription: PropTypes.func.isRequired,
  clearStripeSetupIntent: PropTypes.func.isRequired,
  lastFourDigits: PropTypes.string,
  fetchAllMembershipsForAccount: PropTypes.func.isRequired,
  fetchStripeSetupIntent: PropTypes.func.isRequired,
  fetchStripeSubscriptions: PropTypes.func.isRequired,
  flashErrorMessage: PropTypes.func.isRequired,
  membership: MembershipType.isRequired,
  stripeCustomerId: PropTypes.string,
  stripeSetupIntent: StripeSetupIntentType,
  updateARBCreditCard: PropTypes.func.isRequired,
  updateBillingAddress: PropTypes.func.isRequired,
}

function Billing({
  account,
  activeStripeSubscription,
  cancelStripeSubscription,
  clearStripeSetupIntent,
  lastFourDigits,
  fetchAllMembershipsForAccount,
  fetchStripeSetupIntent,
  fetchStripeSubscriptions,
  flashErrorMessage,
  membership,
  stripeCustomerId,
  stripeSetupIntent,
  updateARBCreditCard,
  updateBillingAddress,
}) {
  const { sfid: accountId } = account

  useEffect(() => {
    if (stripeCustomerId) {
      fetchStripeSubscriptions(stripeCustomerId)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stripeCustomerId])

  const refreshData = async () => {
    await fetchAllMembershipsForAccount(accountId)
    if (stripeCustomerId) {
      await fetchStripeSubscriptions(stripeCustomerId)
    }
  }

  const handleCancelAutoRenewal = async () => {
    try {
      if (activeStripeSubscription) {
        await cancelStripeSubscription(activeStripeSubscription.id)
      }
      await refreshData()
    } catch (error) {
      flashErrorMessage(API_ERROR_MAP.UNABLE_TO_CANCEL_AUTO_RENEWAL)
    }
  }

  return (
    <>
      <MembershipPageHeader membership={membership} />

      <section className="form-block-container">
        <MembershipNotifications membership={membership} />
        <div className="card">
          <BillingDetails
            membership={membership}
            withAutoRenewStatus
            withRenewNowCta
          />
        </div>
        <AutoRenewal
          clearStripeSetupIntent={clearStripeSetupIntent}
          fetchStripeSetupIntent={fetchStripeSetupIntent}
          flashErrorMessage={flashErrorMessage}
          handleCancelAutoRenewal={handleCancelAutoRenewal}
          lastFour={lastFourDigits}
          membership={membership}
          onSuccess={refreshData}
          stripeCustomerId={stripeCustomerId}
          stripeSetupIntent={stripeSetupIntent}
          update={updateARBCreditCard}
        />
        <BillingAddress
          account={account}
          refresh={() => fetchAllMembershipsForAccount(accountId)}
          update={updateBillingAddress}
        />

        {/* <PaymentHistory /> */}
      </section>
    </>
  )
}

Billing.propTypes = propTypes

function mapStateToProps(state) {
  return {
    account: selectors.account(state),
    activeStripeSubscription: memberSelectors.activeStripeSubscription(state),
    lastFourDigits: selectors.lastFourDigits(state),
    membership: memberSelectors.membership(state),
    stripeCustomerId: selectors.stripeCustomerId(state),
    stripeSetupIntent: memberSelectors.stripeSetupIntent(state),
  }
}

const mapDispatchToProps = {
  flashErrorMessage,
}

const mapApiAuthToProps = {
  clearStripeSetupIntent: actions.clearStripeSetupIntent,
  cancelStripeSubscription: apiActions.cancelStripeSubscription,
  fetchAllMembershipsForAccount: apiActions.fetchAllMembershipsForAccount,
  fetchStripeSetupIntent: apiActions.fetchStripeSetupIntent,
  fetchStripeSubscriptions: apiActions.fetchStripeSubscriptions,
  updateARBCreditCard: apiActions.updateARBCreditCard,
  updateBillingAddress: apiActions.updateBillingAddress,
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withApiAuth(mapApiAuthToProps),
)(Billing)
